import type { OHLCV } from '@shared/types/candle'

import { registerIndicator } from '@/indicators/registry'
import type { IndicatorConfig, IndicatorResult } from '@/types/indicator'
import { IndicatorBase } from '@/types/indicator'

const BULL_COLOR = 'rgba(38, 166, 154, 0.6)'
const BEAR_COLOR = 'rgba(239, 83, 80, 0.6)'

const CONFIG: IndicatorConfig = {
  id: 'volume',
  name: 'Volume',
  shortName: 'Vol',
  category: 'volume',
  overlay: true,
  params: [],
  lines: [
    {
      key: 'volume',
      label: 'Volume',
      color: BULL_COLOR,
      width: 1,
      renderStyle: 'histogram',
    },
  ],
}

class Volume extends IndicatorBase {
  readonly config = CONFIG

  calculate(candles: OHLCV[], _params: Record<string, number | string | boolean>): IndicatorResult {
    const values: (number | null)[] = new Array<number | null>(candles.length)
    const colors: (string | null)[] = new Array<string | null>(candles.length)

    for (let i = 0; i < candles.length; i++) {
      const c = candles[i]
      values[i] = c.v
      colors[i] = c.c >= c.o ? BULL_COLOR : BEAR_COLOR
    }

    return { lines: [{ key: 'volume', values, colors }] }
  }
}

registerIndicator(Volume, CONFIG)
